export default "__VITE_ASSET__98ffb9cc__$_?component__"